import { Component, Inject, Injectable, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { LightningModalTypes } from '../../../../../core/classes/modal-types.enum';

@Component({
  selector: 'app-warning-hotel',
  templateUrl: './warning-modal.component.html',
  styleUrls: ['./warning-modal.component.scss'],
  standalone: false
})
@Injectable()
export class WarningModalComponent {
  constructor(public activeModal: NgbActiveModal) {}

  onAccept(): void {
    this.activeModal.close(true);
  }

  onCancel(): void {
    this.activeModal.close();
  }
}
LightningModalTypes.WarningModalComponent.component = WarningModalComponent;
